import { APIResult } from 'src/modules/models/api-result';

export class DocumentSearchResult extends APIResult {
    data: any = []
    total: number = 0;
}

export class DocumentPreviewResult extends APIResult {
    data: string;
}